const EMOTIONAL_AXES = [
  { key: 'warmth', label: 'Warmth', color: '#ffb36b' },
  { key: 'futurity', label: 'Futurity', color: '#6bbcff' },
  { key: 'chaos', label: 'Chaos', color: '#ff7ac8' },
  { key: 'sacredness', label: 'Sacredness', color: '#f8d66d' },
  { key: 'organicness', label: 'Organicness', color: '#6fe3a1' },
  { key: 'nostalgia', label: 'Nostalgia', color: '#cfa9ff' },
  { key: 'surrealism', label: 'Surrealism', color: '#8aa4ff' },
  { key: 'isolation', label: 'Isolation', color: '#93a0c3' }
]

export default class EvolutionLabPanel {
  init(root, { lab, onStateChange }) {
    this.lab = lab
    this.onStateChange = onStateChange
    this.element = null
    this.modifierInputs = new Map()
    this.modifierValues = new Map()
    
    this.createPanel(root)
  }

  createPanel(root) {
    this.element = document.createElement('aside')
    this.element.className = 'evolution-lab-panel'
    this.element.innerHTML = `
      <div class="evolution-lab-panel__title">SYMBOLIC EVOLUTION LAB</div>
      <div class="evolution-lab-panel__body">
        <div class="evolution-lab-panel__section">
          <div class="evolution-lab-panel__section-title">EMOTIONAL MODIFIERS</div>
          <div class="evolution-lab-panel__modifiers"></div>
        </div>
        
        <div class="evolution-lab-panel__section">
          <div class="evolution-lab-panel__section-title">LAB CONTROLS</div>
          <div class="evolution-lab-panel__controls">
            <label class="evolution-lab-panel__toggle">
              <input type="checkbox" data-control="freeze" />
              <span>Freeze Evolution</span>
            </label>
            
            <label class="evolution-lab-panel__toggle">
              <input type="checkbox" data-control="experimental" />
              <span>Experimental Mode</span>
            </label>
            
            <button class="evolution-lab-panel__button" data-action="reset">
              Reset All
            </button>
          </div>
        </div>
        
        <div class="evolution-lab-panel__section">
          <div class="evolution-lab-panel__section-title">HYBRIDIZATION</div>
          <div class="evolution-lab-panel__hybrid-info">
            Select 2+ territories to create hybrids
          </div>
          <button class="evolution-lab-panel__button" data-action="generate-hybrid" disabled>
            Generate Hybrid
          </button>
        </div>
      </div>
    `
    
    // Add modifier controls
    const modifiersContainer = this.element.querySelector('.evolution-lab-panel__modifiers')
    EMOTIONAL_AXES.forEach(axis => {
      const row = document.createElement('label')
      row.className = 'evolution-lab-panel__modifier-row'
      row.innerHTML = `
        <div class="evolution-lab-panel__modifier-head">
          <span style="color: ${axis.color}">${axis.label}</span>
          <strong data-value="${axis.key}">0.00</strong>
        </div>
        <input
          data-modifier="${axis.key}"
          type="range"
          min="-1"
          max="1"
          step="0.01"
          value="0"
        />
      `
      
      const input = row.querySelector('input')
      const value = row.querySelector(`[data-value="${axis.key}"]`)
      
      input.addEventListener('input', () => {
        this.onStateChange('modifier', axis.key, Number(input.value))
        this.renderValues()
      })
      
      this.modifierInputs.set(axis.key, input)
      this.modifierValues.set(axis.key, value)
      modifiersContainer.appendChild(row)
    })
    
    // Add control event listeners
    const freezeToggle = this.element.querySelector('[data-control="freeze"]')
    const experimentalToggle = this.element.querySelector('[data-control="experimental"]')
    const resetButton = this.element.querySelector('[data-action="reset"]')
    const hybridButton = this.element.querySelector('[data-action="generate-hybrid"]')
    
    freezeToggle.addEventListener('change', () => {
      this.onStateChange('toggle', 'freeze', freezeToggle.checked)
    })
    
    experimentalToggle.addEventListener('change', () => {
      this.onStateChange('toggle', 'experimental', experimentalToggle.checked)
    })
    
    resetButton.addEventListener('click', () => {
      this.onStateChange('action', 'reset')
    })
    
    hybridButton.addEventListener('click', () => {
      this.onStateChange('action', 'generate-hybrid')
    })
    
    this.hybridButton = hybridButton
    
    root.appendChild(this.element)
    this.renderValues()
  }

  renderValues() {
    if (!this.element) return
    
    const state = this.lab.getState()
    
    // Update modifier values
    EMOTIONAL_AXES.forEach(axis => {
      const input = this.modifierInputs.get(axis.key)
      const value = this.modifierValues.get(axis.key)
      
      if (input) {
        input.value = String(state.emotionalModifiers[axis.key] || 0)
      }
      
      if (value) {
        value.textContent = (state.emotionalModifiers[axis.key] || 0).toFixed(2)
      }
    })
    
    // Update toggle states
    const freezeToggle = this.element.querySelector('[data-control="freeze"]')
    const experimentalToggle = this.element.querySelector('[data-control="experimental"]')
    
    if (freezeToggle) {
      freezeToggle.checked = state.isFrozen || false
    }
    
    if (experimentalToggle) {
      experimentalToggle.checked = state.isExperimentalMode || false
    }
    
    // Update hybrid button state
    const selectedCount = state.selectedTerritories.size
    if (this.hybridButton) {
      this.hybridButton.disabled = selectedCount < 2
      this.hybridButton.textContent = selectedCount >= 2 
        ? `Generate Hybrid (${selectedCount} selected)` 
        : 'Select 2+ territories'
    }
  }

  updateSelectedTerritories(count) {
    if (this.hybridButton) {
      this.hybridButton.disabled = count < 2
      this.hybridButton.textContent = count >= 2 
        ? `Generate Hybrid (${count} selected)` 
        : 'Select 2+ territories'
    }
  }
}